<template>
  <div class="ad-tree__wrapper">
    <div class="ad-tree__market">
      <gj-market-select
          ref="marketSelect"
          :value="marketId"
          init-value
          :clearable="false"
          @input="marketChange($event)"
          width="130px"
      ></gj-market-select>
      <div class="ad-tree--time">
        <gj-local-time :label="localCountry" :time="localTime"></gj-local-time>
      </div>
    </div>
    <div class="ad-tree__body">
      <el-row
          type="flex"
          class="ad-tree__home"
          v-gutter="10">
        <gj-button
            type="icon"
            plain
            style="font-size: 18px;"
            @click="goHome()">
          <gj-icon iconfont="iconicon_home"></gj-icon>
        </gj-button>
        <gj-input
            v-model="searchText"
            maxlength="80"
            placeholder="搜索广告活动"
            width="170px"
        ></gj-input>
      </el-row>
      <el-row class="tree-content">
        <el-tree
          accordion
          ref="tree"
          node-key="campaignId"
          v-loading="treeLoading"
          :expand-on-click-node="false"
          :data="aDtreeData"
          :filter-node-method="filterNode"
          :default-expanded-keys="['已启用']">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <!-- 状态  -->
            <div class="tree-title" v-if="data.adsLever == 0">
              <span>{{ data.stateName }}</span>
            </div>
            <!-- 广告活动  -->
            <div class="tree-cell" :class="{'active-click': (adStore.SD.campaign && !adStore.SD.group &&  data.campaignId == adStore.SD.campaign.campaignId)}" @click="routeClick('campaign', data, node)" v-else-if="data.adsLever == 2">
              <span class="status-title" :class="`status${data.state}`"></span>
              <span class="status-main" :title="data.campaignName">{{ data.campaignName }}</span>
              <div class="new-page">
                <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SD"
                  :campaign="data">
                  <gj-tooltip content="新标签页打开" >
                    <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                  </gj-tooltip>
                </app-ad-route-link>
              </div>
            </div>
            <!-- 广告组  -->
            <div class="tree-cell" :class="{'active-click': (adStore.SD.group && data.groupId == adStore.SD.group.groupId)}" @click="routeClick('group', data, node)" v-else-if="data.adsLever == 3">
              <span class="status-title" :class="`status${data.state}`"></span>
              <span class="status-main" :title="data.groupName">{{ data.groupName }}</span>
              <div class="new-page">
                <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SD"
                  :campaign="data"
                  :group="data">
                  <gj-tooltip content="新标签页打开" >
                    <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                  </gj-tooltip>
                </app-ad-route-link>
              </div>
            </div>
          </div>
        </el-tree>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { isMeaningful, queryParamsMap } from "@/utils/common";
  import { adStore } from "modules/ad/common/store";
  import { getMarket } from "@/api/common";
  import { optionText } from "@/filters";
  import { countryOption } from "@/utils/options";
  import { Portfolios, adSdCampaignGrouping, listProductBrand, getSdAdGroupPage } from "@/api/ad";
  import { AdTypeEnum } from "modules/ad/common/enum";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";

  export default {
    name: "app-sd-ad-tree",
    inject: ['removeTabList', 'getNavTabs'],
    components: { AppAdRouteLink },
    props: {
      initMarketId: {
        required: false
      }
    },
    watch: {
      searchText(val) {
        this.treeFilter(this, val)

      }
    },
    created() {
      if (isMeaningful(this.initMarketId)) {
        this.marketChange(this.initMarketId);
      }
    },
    data() {
      return {
        adStore,
        AdTypeEnum,
        marketId: null,
        portfolioId: null,
        localTime: null,
        treeLoading: false,
        localCountry: '',
        searchText: '',
        treeStatus: ["已启用", "已停用", "已归档"],
        aDtreeData: [], // 广告活动树数据
      }
    },
    methods: {
      // 树结构过滤
      treeFilter: _.debounce(((vm, val) => {
        // vm.$refs.tree.filter(val);
        vm.aDtreeDataInit(vm.marketId, val)
      }), 300),
      // 判断是否有品牌
      async listProductBrand(marketId) {
        this.adStore.SD.isBrand = 0
        try {
          let { data } = await listProductBrand({marketId})
          this.adStore.SD.isBrand = data.length > 0 ? 2 : 1;
        } catch (error) {
          this.adStore.SD.isBrand = 1
        }
      },
      // 广告活动树过滤
      filterNode(value, data) {
        if (!value) return true
        let valueMap = value.toLowerCase()
        if (data.adsLever == 0) {
          return true
        }else if(data.adsLever == 1) {
          return data.portfolioName && data.portfolioName.toLowerCase().indexOf(valueMap) !== -1;
        }else if(data.adsLever == 2) {
          return data.campaignName && data.campaignName.toLowerCase().indexOf(valueMap) !== -1;
        }else if(data.adsLever == 3) {
          return data.groupName && data.groupName.toLowerCase().indexOf(valueMap) !== -1;
        }
      },
      // 初始化广告活动树结构
      async aDtreeDataInit(marketId, campaignName = '') {
        if (!marketId) return false
        this.treeLoading = true
        try {
          let { data = [] } = await adSdCampaignGrouping({ marketId, campaignName })
          data.forEach(item => {
            item.campaignId = item.stateName
            item.campaignName = item.stateName
            item?.children?.forEach(j => {
              j?.children?.forEach(e => {
                e.campaignId = j.campaignId
                e.campaignName = j.campaignName
              })
            })
          })
          this.aDtreeData = data
        } finally {
          this.treeLoading = false
        }
      },
      // 点击广告活动
      routeClick(type, data, node) {
        // if (!this.$permission('adsSdCampaigns:update')) {
        //   return false
        // }
        const opt = {
          campaign: () => {
            adStore.SD.campaign = data;
            adStore.SD.group = null;
          },
          group: () => {
            adStore.SD.campaign = node.parent.data;
            adStore.SD.group = data;
            // 获取组type
            // const params = {
            //   model: {
            //     marketId: this.marketId,
            //     campaignId: node.parent.data.campaignId
            //   },
            // };
            // getSdAdGroupPage(params).then( res  => {
            //   let sign = res.records.find(e => e.groupId == data.groupId)
            //   adStore.SD.group = sign
            // })
          },
        }
        opt[type]()
      },
      // 回到首页
      goHome() {
        adStore.SD.campaign = null;
        adStore.SD.group = null;
        this.searchText = "";
        this.$emit("goHome")
      },
      marketChange(marketId, activeTab = null) {
        if (marketId !== this.marketId) {
          this.getPortfolio(marketId);
          this.aDtreeDataInit(marketId)
          this.getMarket(marketId);
          this.marketId = marketId;
          this.$emit('market-change', this.marketId);
        }
      },
      getMarket(marketId) {
        return getMarket(marketId)
          .then((market) => {
            adStore.SD.market = market;
            adStore.SD.marketId = marketId;
            adStore.SD.currencySymbol = market.currencySymbol;
            adStore.SD.isAdsAuth = market.isAdsAuth;
            this.localTime = market.datetime;
            this.localCountry = optionText(market.countryCode, countryOption);
            this.$emit("getLocal", this.localTime, this.localCountry)
          })
      },
      getPortfolio(marketId) {
        // 查询广告组合
        this.treeLoading = true;
        Portfolios.getPortfolios({marketId: marketId || this.marketId})
          .then(({data}) => {
            adStore.SD.portfolios = data;
          })
          .complete(() => {
            this.treeLoading = false;
          });
      },
      routeTo(marketId, activeTab) {
        this.$router.push(`/ad/sd-ad/ad-manager?${queryParamsMap({
            marketId,
            portfolioId: this.portfolioId,
            activeTab,
          })}`,
          onComplete => {},
          onAbort => {}
        );
      },
    }
  }
</script>

<style scoped lang="scss">
  .ccc {
    color: #999;
    cursor: auto;
  }
  .search {
    padding: 0 10px 10px;
    /deep/.el-input__inner {
        border-width: 0;
        border-bottom-width: 1px;
        border-radius: 0;
        padding-left: 0;
        padding-right: 40px;
    }
    /deep/.el-input-group__append {
        border: 0;
        background: #fff;
        position: absolute;
        top: 0;
        right: 23px;
        padding: 0;
        width: 0;
    }
    /deep/.el-input__suffix {
      left: 145px;
    }
  }
  .el-icon-search {
    cursor: pointer;
  }
  /deep/.el-tree-node__expand-icon {
    font-size: 15px;
  }
  /deep/.el-tree-node__content {
    height: 30px;
  }
  /deep/.el-icon-caret-right {
    color: #999;
    &.el-tree-node__expand-icon.is-leaf {
      color: transparent;
    }
  }
  .tree-content {
    height: calc(100vh - 316px);
    padding-top: 8px;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 12px;
    color: #666;
    &::-webkit-scrollbar-track { 
      background: #fff;
    }
    .custom-tree-node {
      width: 80%;
      line-height: 30px;
      .tree-cell {
        color: #666;
        .status-main {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 150px;
          line-height: 1;
        }
        .new-page {
            display: none;
          }
        &:hover {
          .status-main {
            max-width: 135px;
          }
          .new-page {
            display: inline-block;
          }
        }
      }
      .tree-title {
        display: flex;
        align-items: center;
        color: #000;
        font-weight: 500;
      }
      .status-title {
        width: 6px;
        height: 6px;
        border-radius: 100%;
        margin-right: 2px;
        display: inline-block;
        background: #999;
        transform: translateY(-1px);
        &.status0 {
          background: #1F6EEF;
        }
        &.status1 {
          background: #ddd;
        }
      }
      .active-click {
        color: #1F6EEF;
      }
    }
  }
  .ad-tree__market {
    padding: 5px 10px 15px;
    border-bottom: 1px solid #EBEEF5;
    position: relative;
  }
  .ad-tree--time {
    color: #444;
    font-size: 12px;
  }
  .ad-tree__header {
    padding: 0 10px;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
    height: 40px;
    box-sizing: border-box;
  }
  .ad-tree__header--title {
    color: #8b8c8d;
    font-weight: 700;
  }
  .ad-tree__header--op {
    font-size: 14px;
    padding: 0;
    color: #999;
  }
  .ad-tree__body {
    padding: 15px 0 0 0;
    .ad-switch {
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .switch-cell {
        position: relative;
        width: 78px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background: #EDF7FF;
        // border-radius: 2002px;
        border: 1px solid #D8DADD;
        cursor: pointer;
        color: #666;
        &:first-child {
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
        }
        &:last-child {
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
        &.active {
          z-index: 2;
          color: #1F6EEF;
          border: 1px solid #1F6EEF;
          background: #EDF7FF;
          font-weight: bold;
        }
      }
    }
  }
  .ad-tree__home {
    padding: 0 10px 10px;
    border-bottom: 1px solid #EBEEF5;
  }
  
  .ad-tree__market /deep/ .el-select input  {
    border: none;
    padding: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .ad-tree__market /deep/ .el-select .el-input .el-input__suffix {
    right: -22px;
    background: #fff;
  }
  
  .ad-tree__market /deep/ .el-select .el-input .el-select__caret {
    color: #999;
    font-weight: bold;
  }
  .ad-tree__market{
    /deep/ .el-input__inner{
      &:focus{
        box-shadow: none;
      }
    }
  }

  .ad-tree-node__content {
    height: 30px;
    cursor: pointer;
    font-size: 12px;
    padding: 0 10px;
    box-sizing: border-box;
    color: #606266;
  }

  .ad-tree-node__content:hover {
    background-color: #F5F7FA;
  }
  .ad-tree-node__content.active {
    border: 1px solid #30adff;
    color: #30adff;
    background-color: #f0f7ff;
  }
</style>
